import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertService } from '@michelin/theme';

@Component({
  selector: 'mic-root',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet],
  providers: [AlertService]
})
export class AppComponent {}
